import { ArrowBendUpLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Reply = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ArrowBendUpLeftIcon {...rest} size={Sizes[size]} color={fill} />;
};

Reply.displayName = 'Reply';
